export const dateFormatted = (date: string) => new Date(date).getDate().toString()
